import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=7e5f2ef7&scoped=true"
import script from "./Education.vue?vue&type=script&setup=true&lang=js"
export * from "./Education.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Education.vue?vue&type=style&index=0&id=7e5f2ef7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f2ef7",
  null
  
)

export default component.exports